import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import NoticeCard from '../Common/NoticeCard';
import { Notice } from '../../types/Notice';
import api from '../../services/api';

const NoticeDetails: React.FC = () => {
  const { id } = useParams();
  const [notice, setNotice] = useState<Notice | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await api.get(`/notices/${id}`);
        if (res.data?.success) {
          setNotice(res.data.data);
        } else {
          setError(res.data?.message || 'Failed to load notice');
        }
      } catch (e: any) {
        setError(e.response?.data?.message || 'Failed to load notice');
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id]);

  if (loading) {
    return (
      <div className="notice-detail-page">
        <div className="loading-spinner" />
        <p>Loading notice...</p>
      </div>
    );
  }

  if (error || !notice) {
    return (
      <div className="notice-detail-page">
        <div className="error-message">
          <h3>Notice not found</h3>
          <p>{error}</p>
          <Link className="btn btn-primary" to="/notices">Back to notices</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="notice-detail-page">
      <div className="page-header">
        <Link to="/notices" className="btn btn-outline-secondary">← Back to notices</Link>
      </div>
      <NoticeCard notice={notice} showFullContent={true} className="notice-detail-card" />
    </div>
  );
};

export default NoticeDetails;


